var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ContractorInvite", {
        attrs: {
          role: "CONTRACTOR",
          companyBusinessName: _vm.companyBusinessName,
          companyId: _vm.companyId,
          currentUserId: _vm.currentUserId,
          isManager: _vm.isManager,
        },
        model: {
          value: _vm.contractorDialog,
          callback: function ($$v) {
            _vm.contractorDialog = $$v
          },
          expression: "contractorDialog",
        },
      }),
      _c(
        "UiButtonTest",
        {
          staticClass: "mr-12",
          attrs: {
            disabled: _vm.noCompany,
            buttonClasses: "customHeight40",
            id: "uploadContractortest",
            size: _vm.size,
            variant: "black",
            iconStyle: "w-2",
          },
          on: { click: _vm.handleInviteClick },
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "18",
                        height: "18",
                        viewBox: "0 0 16 16",
                        fill: "none",
                      },
                    },
                    [
                      _c(
                        "g",
                        { attrs: { "clip-path": "url(#clip0_2964_15353)" } },
                        [
                          _c("path", {
                            attrs: {
                              d: "M9.23077 1.23077C9.23077 0.55 8.68077 0 8 0C7.31923 0 6.76923 0.55 6.76923 1.23077V6.76923H1.23077C0.55 6.76923 0 7.31923 0 8C0 8.68077 0.55 9.23077 1.23077 9.23077H6.76923V14.7692C6.76923 15.45 7.31923 16 8 16C8.68077 16 9.23077 15.45 9.23077 14.7692V9.23077H14.7692C15.45 9.23077 16 8.68077 16 8C16 7.31923 15.45 6.76923 14.7692 6.76923H9.23077V1.23077Z",
                              fill: "white",
                            },
                          }),
                        ]
                      ),
                      _c("defs", [
                        _c("clipPath", { attrs: { id: "clip0_2964_15353" } }, [
                          _c("rect", {
                            attrs: { width: "18", height: "18", fill: "white" },
                          }),
                        ]),
                      ]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "hover-icon",
              fn: function () {
                return [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "17",
                        height: "16",
                        viewBox: "0 0 17 16",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M9.73077 1.23077C9.73077 0.55 9.18077 0 8.5 0C7.81923 0 7.26923 0.55 7.26923 1.23077V6.76923H1.73077C1.05 6.76923 0.5 7.31923 0.5 8C0.5 8.68077 1.05 9.23077 1.73077 9.23077H7.26923V14.7692C7.26923 15.45 7.81923 16 8.5 16C9.18077 16 9.73077 15.45 9.73077 14.7692V9.23077H15.2692C15.95 9.23077 16.5 8.68077 16.5 8C16.5 7.31923 15.95 6.76923 15.2692 6.76923H9.73077V1.23077Z",
                          fill: "black",
                          "fill-opacity": "0.88",
                        },
                      }),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "flex flex-initial" }, [
            _vm._v(_vm._s(_vm.actionButtonContent)),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }